import * as React from 'react';
import * as Clients from '../../client/ApiClient';
import { authentication } from '../../services/Authentication';
import { DataTable, DataRow, DataCell, DataTableButton } from 'components/basic/DataTable';
import Toolbar from '../basic/Toolbar';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Input, Button } from 'reactstrap';
import { RangePagination, RangePaginationState, paginate } from 'components/basic/Pagination';
import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
import { enqueueNotification } from "../../store/Notifications"
import { store } from "AppContext"
import * as FileTypes from 'constants/FileUploadType';
import CloseConfirmationModal from '../basic/modals/CloseConfirmationModal';
import ConfirmationModal from '../basic/modals/ConfirmationModal';
import { useRef } from "react";
import { resolveAny } from 'dns';

interface IClientMergePageState {
    clients: Clients.ClientMergeModel[];
    options: { [key: string]: Clients.ConversionOptionValueModel } | undefined;
    selectedFile: any;
    pagination: RangePaginationState;
    hubConnection: HubConnection | null;
    hubConnected: boolean;
    running: boolean;
    buttonLock: boolean;
    closeConfirmationModal: boolean,
    confirmationModal: boolean,
    errMessage: string,
    uploadId: string | null;
}
interface ClientMergeArgs {
    conversionId: string,
}

type ClientMergeProps = RouteComponentProps<ClientMergeArgs>;

class ClientMergePage extends React.Component<ClientMergeProps, IClientMergePageState>{
    private readonly clientMerge: Clients.ClientMergeClient = new Clients.ClientMergeClient();
    private options: Clients.ConversionOptionsClient = new Clients.ConversionOptionsClient();
    private executions: Clients.ExecutionsClient = new Clients.ExecutionsClient();
    private conversionId: string = '';
    private custFileQueued: boolean = false;
    private custFileUploaded: boolean = false;
    private statusPollInterval: ReturnType<typeof setInterval> | null = null;
    public isFromCSVValidation: boolean = false;
    constructor(props: Readonly<ClientMergeProps>) {
        super(props)
        this.state = {
            clients: [],
            options: undefined,
            selectedFile: null,
            pagination: {
                pageSize: 25,
                pageNumber: 0,
            },
            hubConnection: null,
            hubConnected: false,
            running: false,
            buttonLock: true,
            closeConfirmationModal: false,
            confirmationModal: false,
            errMessage: '',
            uploadId: null,
        }
    }

    componentDidMount() {
        this.conversionId = this.props.match.params.conversionId;
        this.buttonLock();
        this.refreshList(false);
        this.getOptions();        
        const link = `${process.env.PUBLIC_URL}/stagesignal`
        const hubConnection = new HubConnectionBuilder().withUrl(link).withAutomaticReconnect().build();
        this.setState({ hubConnection }, () => {
            this.state.hubConnection!
                .start()
                .then(() => {
                    console.log('[SignalR] Connected');
                    this.setState({ hubConnected: true });
                    this.state.hubConnection!.invoke('JoinConversionGroup', this.conversionId);
                    this.checkForInProgressUpload();
                })
                .catch(err => {
                    console.log('Error while establishing connection :(');
                    this.checkForInProgressUpload();
                });
            this.state.hubConnection!.onclose(() => {
                console.log('[SignalR] Disconnected');
                this.setState({ hubConnected: false });
                if (this.state.running && this.state.uploadId) {
                    this.startStatusPoll(this.state.uploadId);
                }
            });
            this.state.hubConnection!.on('MergeComplete', (done: string) => {
                this.stopStatusPoll();
                this.setState({ running: false, uploadId: null });
                this.refreshList(true);
            });
            let reload = 0;
            this.state.hubConnection!.on('MergeRunning', (running: string) => {
                reload += 1;
                if (reload === 15 || reload % 100 === 0) {
                    this.refreshList(false);
                }
                if (!this.state.running) {
                    this.setState({ running: true })
                }
            });
            this.state.hubConnection!.on('ClientMergeWorkbookProtected', (done: string) => {
                this.stopStatusPoll();
                this.popErrMessage("Client Merge file has restricted access, is password protected or is not an Excel document. File cannot be uploaded.");
            });
            this.state.hubConnection!.on('ClientMergeError', (done: string) => {
                this.stopStatusPoll();
                this.popErrMessage("An error occurred. File cannot be uploaded.");
            });
            this.state.hubConnection!.on('MergeFail', (errMsg: string) => {
                this.stopStatusPoll();
                this.refreshList(false);
                store.dispatch(enqueueNotification({ type: 'error', message: errMsg == 'fail' ? 'File is in incorrect orientation. Please see file example.' : errMsg }));
                this.setState({ running: false, uploadId: null });
            });
            this.state.hubConnection!.onreconnected(() => {
                console.log('[SignalR] Reconnected');
                this.setState({ hubConnected: true });
                this.state.hubConnection!.invoke('JoinConversionGroup', this.conversionId);
                this.stopStatusPoll();
                if (this.state.running) {
                    this.refreshList(true);
                }
            });
            if (this.state.hubConnected && this.state.hubConnection!.state == HubConnectionState.Disconnected) {
                store.dispatch(enqueueNotification({ type: 'error', message: "User session has been disconnected." }));
                authentication.logout()
                    .then(() => this.props.history.push('/'))
                    .catch(error => { }
                    )
            };
        })
    }

    private popErrMessage = (message: string) => {
        this.setState({ running: false });
        if (this.state.clients.length > 0) { this.refreshList(true); }
        this.setState({ errMessage: message });
        this.openConfirmationModal();
    }

    openConfirmationModal = () => {
        this.setState({ confirmationModal: true })
    }
    private gotoFileUploads = () => {
        this.setState({ closeConfirmationModal: false, confirmationModal: false });
        this.refreshPage('additionaldata');
    }
    refreshPage = (landingTab: string) => {
        window.location.reload();
        this.props.history.push({
            pathname: window.location.href.split('/').pop(),
            state: { tabName: landingTab }
        });
    }
    removeConfirmationModal = () => {
        this.setState({ closeConfirmationModal: false, confirmationModal: false });
    }
    openCloseConfirmationModal = () => {
        this.setState({ closeConfirmationModal: true })
    }

    refreshList = (done: boolean) => {
        this.clientMerge.getAll(this.conversionId)
            .then(response => {
                this.setState({
                    clients: response!
                }, () => {
                    if (done) {
                        if (this.state.clients.length > 0) {
                            store.dispatch(enqueueNotification({ type: 'success', message: "Complete" }))
                            this.openCloseConfirmationModal();
                        } else {
                            store.dispatch(enqueueNotification({ type: 'error', message: "File is in incorrect orientation. Please see file example." }));
                            this.setState({ running: false });
                            this.isFromCSVValidation = false;
                        }
                    }
                })
            })
            .catch(error => { });
    }
    getOptions = () => {
        this.options.get(this.conversionId)
            .then(values => {
                const options = values!.reduce(
                    (result, current) => ({ ...result, [current.id!]: current, }), {});
                this.setState({ options });
            })
            .catch(e => {
                console.log(e)
            })
    }
    setOption = (optionId: string, optionValue: string) => {
        const optionsClient: Clients.ConversionOptionsClient = new Clients.ConversionOptionsClient();
        const optionModel: Clients.ConversionOptionValueModel[] = [];
        const valuesArray: any = {
            conversionId: this.conversionId,
            value: optionValue,
            isLocked: false,
            id: optionId,
        };
        optionModel.push(valuesArray);
        optionsClient.update(this.conversionId, optionModel);
    }


    handleFileInput = (event: React.ChangeEvent) => {
        let selectedFile = (event.target as HTMLInputElement).files![0];
        if ((event.target as HTMLInputElement).files!.length > 0) {
            if (selectedFile.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                this.isFromCSVValidation = true;
                store.dispatch(enqueueNotification({ type: 'error', message: "Please upload Excel files (.xlsx) only." }));               
                this.state = {
                    clients: [],
                    options: undefined,
                    selectedFile: null,
                    pagination: {
                        pageSize: 25,
                        pageNumber: 0,
                    },
                    hubConnection: null,
                    hubConnected: false,
                    running: false,
                    buttonLock: true,
                    closeConfirmationModal: false,
                    confirmationModal: false,
                    errMessage: '',
                    uploadId: null,
                };
            }
            else {
                this.setState({ selectedFile });
                this.isFromCSVValidation = false;
            }
        }
        else {
            this.isFromCSVValidation = false;
            if (selectedFile == undefined) {
                this.state = {
                    clients: [],
                    selectedFile: null,
                    pagination: {
                        pageSize: 25,
                        pageNumber: 0,
                    },
                    hubConnection: null,
                    running: false,
                    buttonLock: true,
                    errMessage: '',
                    hubConnected: false,
                    confirmationModal: false,
                    options: undefined,
                    closeConfirmationModal: false,
                    uploadId: null,
                };
            }
        }
    };

    componentWillUnmount() {
        this.stopStatusPoll();
        this.state.hubConnection!.invoke('LeaveConversionGroup', this.conversionId);
        this.state.hubConnection!.stop();
    }

    onFileUpload = () => {
        if (this.state.selectedFile === null) {
            if (this.isFromCSVValidation)
                store.dispatch(enqueueNotification({ type: 'error', message: "Please upload Excel files (.xlsx) only." }))
            else
                store.dispatch(enqueueNotification({ type: 'error', message: "Please upload file." }))
        } else {
            this.setState({ running: true });
            const fileField: any = document.querySelector('input[type="file"]');
            const formData = new FormData();
            const postUrl = '/api/v1/' + this.conversionId + '/fileUpload';

            formData.append("contentType", fileField!.files[0].type);
            formData.append("data", fileField!.files[0]);
            formData.append("fileUploadTypeId", FileTypes.clientMerge);
            formData.append("name", fileField!.files[0].name);

            fetch(postUrl, {
                method: 'POST',
                body: formData
            })
                .then(response => {
                    if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
                    return response.json();
                })
                .then(data => {
                    this.setState({ uploadId: data.id });
                    if (!this.state.hubConnected) {
                        this.startStatusPoll(data.id);
                    }
                    this.clientMerge.getAll(this.props.match.params.conversionId)
                        .then(response => {
                            this.setState({
                                clients: response!
                            })
                        })
                        .catch(error => { });
                })
                .catch(error => {
                    console.log(error);
                    this.setState({ running: false });
                })


        }

    }

    private startStatusPoll = (uploadId: string) => {
        console.log('[SignalR] Starting status poll for upload:', uploadId);
        this.stopStatusPoll();
        this.statusPollInterval = setInterval(() => this.checkUploadStatus(uploadId), 3000);
    };

    private stopStatusPoll = () => {
        if (this.statusPollInterval !== null) {
            clearInterval(this.statusPollInterval);
            this.statusPollInterval = null;
        }
    };

    private checkUploadStatus = (uploadId: string) => {
        fetch(`/api/v1/${this.conversionId}/fileUpload/${uploadId}`)
            .then(r => r.json())
            .then(data => {
                if (data.processingStatus !== null && data.processingStatus !== undefined) {
                    this.stopStatusPoll();
                    this.handleProcessingStatus(data.processingStatus);
                }
            })
            .catch(() => { });
    };

    private handleProcessingStatus = (status: string) => {
        switch (status) {
            case 'Complete':
                this.setState({ running: false, uploadId: null });
                this.refreshList(true);
                break;
            case 'Fail':
                this.setState({ running: false, uploadId: null });
                store.dispatch(enqueueNotification({ type: 'error', message: 'File is in incorrect orientation. Please see file example.' }));
                break;
            case 'Error':
                this.setState({ running: false, uploadId: null });
                store.dispatch(enqueueNotification({ type: 'error', message: 'An error occurred. File cannot be uploaded.' }));
                break;
        }
    };

    private checkForInProgressUpload = () => {
        fetch(`/api/v1/${this.conversionId}/fileUpload`)
            .then(r => r.json())
            .then(uploads => {
                const myUploads = uploads
                    .filter((u: any) => u.fileUploadTypeId === FileTypes.clientMerge)
                    .sort((a: any, b: any) => new Date(b.uploadedOn).getTime() - new Date(a.uploadedOn).getTime());
                const latest = myUploads[0];
                if (latest && latest.processingStatus === null) {
                    this.setState({ running: true, uploadId: latest.id });
                    this.startStatusPoll(latest.id);
                }
            })
            .catch(() => { });
    };

    buttonLock = () => {
        this.executions.listExecutionsAllTierBoolean(this.props.match.params.conversionId)
            .then((response) => {
                if (response) {
                    this.setState({ buttonLock: response.isLocked })
                }
            })
            .catch(error => { })
    }

    public render() {
        return (
            <>
                <Toolbar>
                    <DataTableButton
                        icon='file_download'
                        id={`mergeExample`}
                        title="Merge Excel Example"
                        value="Download"
                        onClick={() => { window.open("/ClientMergeTemplate.xlsx") }} />
                    <Input type="file" name="file" id="exampleFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={e => this.handleFileInput(e)} />
                    {this.state.running ?
                        <img className='loading-indicator' alt="loader" src={'loader.gif'} /> :
                        <Button className='submit-button-orange' onClick={this.onFileUpload} disabled={this.state.buttonLock}>
                            Upload
                        </Button>}
                </Toolbar>
                <DataTable>
                    <thead>
                        <tr>
                            <th className="number-column">#</th>
                            <th>Client Code</th>
                            <th>Merge into Code</th>
                        </tr>
                    </thead>
                    <tbody className="nonEntity">
                        {paginate(this.state.clients, this.state.pagination, (client, i) => (
                            <DataRow key={client.id}
                                id={`${client.id}`}
                            >
                                <DataCell className="number-column">{client.rowNumber}</DataCell>
                                <DataCell>{client.clientCode}</DataCell>
                                <DataCell>{client.mergeIntoCode}</DataCell>
                            </DataRow>
                        ))}
                    </tbody>
                </DataTable >
                <RangePagination
                    pageNumber={this.state.pagination.pageNumber}
                    pageSize={this.state.pagination.pageSize}
                    recordsCount={this.state.clients.length}
                    onChangeIndex={index => this.setState({
                        pagination: {
                            ...this.state.pagination,
                            pageNumber: index,
                        }
                    })}
                />
                <ConfirmationModal
                    isOpen={this.state.confirmationModal}
                    message={this.state.errMessage}
                    onSubmit={this.gotoFileUploads}
                />
            </>
        )
    }
}

export default withRouter(ClientMergePage)